import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { Columns } from '../base/grid';
import { RichText } from '../base/richText/richText';
import RichTextTitle from '../base/richTextTitle';
import Button from '../button-v2';

export const ImageCtaWrapper = styled.div`
	margin-top: 150px;
`;

export const RichTextTitleStyled = styled(RichTextTitle)`
	margin-top: 24px;
	font-weight: ${theme.fonts.weight.bold};

	${media.desktopSmall`
		margin-top: 48px;
	`}

	${media.desktopLarge`
		margin-top: 64px;
	`}
`;

export const TextWrapper = styled.div`
	margin-top: 64px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;

	${media.desktopSmall`
		margin-top: 0;
	`}
`;

export const ButtonStyled = styled(Button)`
	margin-top: 32px;
	display: inline-flex;
	align-self: flex-start;
`;

export const DescriptionRichText = styled(RichText)`
	margin-top: 24px;
`;

export const Image = styled.img`
	height: 100%;
	max-width: 100%;
	max-height: 550px;
	border-radius: 16px;

	${media.desktopSmall`
		max-height: 680px;
	`}
`;

export const ImageWrapper = styled.div`
	display: flex;
`;

export const ColumnsStyled = styled(Columns)`
	margin-bottom: 0;
	flex-direction: column-reverse;

	${media.desktopSmall`
		flex-direction: row;
        justify-content: space-between;
    `}
`;
